import { format, utcToZonedTime } from 'date-fns-tz'

export const dateFormat = (
  date: string | Date,
  template: string
): any => {
  if (date) {
    return format(utcToZonedTime(date, 'Asia/Bangkok'), template)
  }
}